import styles from './Product.module.scss';
import { AppBreakpoint } from '../../../../../../../../../../../../../lib/util/Adaptive';
import { useWindowResize } from '../../../../../../../../../utils/hooks/useWindowResize';
import { useProductRowPrice } from '../../../../../../../hooks/useProductRowPrice';
import { getRulesProductPrice } from '../../../../../../../../../utils/rules/product_price_rules_helper';
import {
  checkCanShowProductAmount,
  getMultipleProductAmount,
  getResultProductName,
} from '../../../../../../../components/PreviewResultLayout/helpers';

const empfehlung = 'Empfehlung';

export function Product({ product, fonts, colors, pagesFlow, productInformation, isRecommended }) {
  const { windowWidth } = useWindowResize();
  const { showPrice, rulePrice, rulePriceType } = getRulesProductPrice(product, pagesFlow, [], false);
  const price = useProductRowPrice(product, productInformation, showPrice, rulePrice, rulePriceType);
  const productName = getResultProductName(productInformation, product);

  const multipleProductAmount = getMultipleProductAmount(product);
  const canShowProductAmount = checkCanShowProductAmount(multipleProductAmount);

  const priceStyle = {
    marginRight: windowWidth > AppBreakpoint.M ? '20px' : undefined,
    fontSize: windowWidth > AppBreakpoint.M ? fonts?.body?.fontSize : fonts?.subText?.fontSize,
    fontFamily: fonts?.body?.font,
    fontWeight: 700,
    color: colors?.[fonts?.body?.colorVariant],
    marginBottom: 0,
    textAlign: 'right',
    flex: '1 1 40%',
  };

  return (
    <div className={styles.productRow}>
      <div className={styles.info}>
        <div className={styles.name} style={{ fontFamily: fonts.body.font }}>
          {canShowProductAmount && <span className={styles.multipleProductAmount}>{`${multipleProductAmount}x`}</span>}
          {productName}
        </div>
        {isRecommended && (
          <div
            className={styles.badge}
            style={{
              backgroundColor: colors?.primaryColor,
              fontFamily: fonts.body.font,
            }}
          >
            {empfehlung}
          </div>
        )}
      </div>
      <div className={styles.priceCol}>
        <div style={priceStyle}>{price}</div>
      </div>
    </div>
  );
}
